/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TagsTag model module.
 * @module model/TagsTag
 * @version v0.3
 */
export default class TagsTag {
  /**
   * Constructs a new <code>TagsTag</code>.
   * @alias module:model/TagsTag
   * @class
   * @param name {String} 
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Constructs a <code>TagsTag</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TagsTag} obj Optional instance to populate.
   * @return {module:model/TagsTag} The populated <code>TagsTag</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TagsTag();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
TagsTag.prototype.name = undefined;

/**
 * @member {String} description
 */
TagsTag.prototype.description = undefined;

